"use client";

import useSignInHref from "./useSignInHref";
import NavElement from "./NavElement";

const NavSignInButton = () => {
	const href = useSignInHref();
	return (
		<NavElement href={href} className="px-4 py-1 text-sm" isExternal>
			Sign In
		</NavElement>
	);
};

export default NavSignInButton;
